import {
  ACCEPT_OFFER,
  ADD_DOCUMENT_DETAILS,
  ADD_EDUCATIONDETAILS,
  ADD_EXPERIENCEDETAILS,
  ADD_FAMILYDETAILS,
  ADD_PERSONALDETAILS,
  APPROVE_NEWHIRE,
  CHANGE_PASSWORD,
  CREATE_USER,
  DESIGNATION_LIST,
  DOCUMENT_LIST,
  EDUCATION_DETAILS,
  EMPLOYEE_LIST,
  EXPERIENCE_DETAILS,
  FAMILY_DETAILS,
  FORGOT_PASSWORD,
  INITIATE_NEWHIRE,
  OFFER_DETAILS,
  OFFER_GENERATE,
  PERSONAL_DETAILS,
  REMOVE_DOCUMENT,
  ROLE_LIST,
  UPDATE_ONBOARDING,
  USER_DETAILS,
  USER_DOCUMENT_LIST,
  USER_LIST,
  VALIDATE_USER,
  EXIT_EMPLOYEE,
  NEW_HIRE_TRANSACTION,
  OFFER_ACCEPTED,
  CONTRACT_EMPLOYEE_LIST,
  SUPPORT_EMPLOYEE_LIST,
  EMPLOYEE_DATA,
  EMPLOYEE_DATA_EXCEL,
  SUPPORT_DATA_EXCEL,
  CONTRACT_DATA_EXCEL,
  ALL_EMPLOYEE_LIST,
  INSTANT_ONBOARD,
} from "./ActionType";
import { BASE_API_URL } from "../../config/Api";

export const validateUser =
  (userData, fieldName, token) => async (dispatch) => {
    try {
      const res = await fetch(`${BASE_API_URL}/validateUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(userData),
      });
      const resData = await res.json();
      if (res.ok) {
        dispatch({
          type: VALIDATE_USER,
          payload: { ...resData, field: fieldName },
        });
      }
    } catch (error) {
      console.error("Validation error:", error);
    }
  };

export const createUser = (userData, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/createUser`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(userData),
    });
    const resData = await res.json();
    dispatch({ type: CREATE_USER, payload: resData });
    return { response: resData };
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const getDesignation = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getDesignation`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: DESIGNATION_LIST, payload: resData });
  } catch (error) { }
};

export const getUserList = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/newHireList`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: USER_LIST, payload: resData });
  } catch (error) { }
};

export const addFamilyDetails = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/addFamilyDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: ADD_FAMILYDETAILS, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const addEducationDetails = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/addEducationDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: ADD_EDUCATIONDETAILS, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const addExperinceDetails = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/addExperienceDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: ADD_EXPERIENCEDETAILS, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const addPersonalDetails = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/addPersonalDetails`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: ADD_PERSONALDETAILS, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const getPersonalDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchPersonalDetails?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: PERSONAL_DETAILS, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const getFamilyDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchFamilyDetails?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: FAMILY_DETAILS, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const getEducationDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchEducationDetails?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: EDUCATION_DETAILS, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const getExperienceDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/fetchExperienceDetails?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: EXPERIENCE_DETAILS, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const getDocumentList = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/documentDetailsList?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: DOCUMENT_LIST, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const addDocumentDetails = (formData, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/uploadDocumentsMulti`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: ADD_DOCUMENT_DETAILS, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const getUserDocumentDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/getDocumentDetails?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: USER_DOCUMENT_LIST, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Validation error:", error);
  }
};

export const initiateNewhire =
  (loginId, intiatorId, token) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/intiateNewHire?loginid=${loginId}&intiatorId=${intiatorId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const resData = await res.json();
      if (res.ok) {
        dispatch({ type: INITIATE_NEWHIRE, payload: resData });
        return resData;
      } else {
        throw new Error(resData.statusDesc || "Unknown error occurred");
      }
    } catch (error) {
      console.error("Validation error:", error);
    }
  };

export const generateOffer = (formData, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/genrateOffer`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
      body: formData,
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: OFFER_GENERATE, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) { }
};

export const updateUserOnboarding = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/updateUserOnboarding`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok && (resData.statusCode === "00" || resData.statusCode =="40")) {
      dispatch({ type: UPDATE_ONBOARDING, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || "Unknown error occurred");
    }
  } catch (error) { }
};

export const getUserByLoginId = (loginId, token, type) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/getUserByLoginID?loginId=${loginId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: type, payload: resData });
  } catch (error) { }
};

export const getRoleList = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/getRoleList`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: ROLE_LIST, payload: resData });
  } catch (error) { }
};

export const getofferDetails = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/offerDetailes?loginId=${loginId}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    dispatch({ type: OFFER_DETAILS, payload: resData });
  } catch (error) { }
};

export const downloadOfferFile = (userId, fileName, token) => async () => {
  try {
    const response = await fetch(
      `${BASE_API_URL}/downloadOfferFile?userId=${userId}&filename=${fileName}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to download file");
    }

    const blob = await response.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};

export const acceptOffer = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/acceptOffer`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: ACCEPT_OFFER, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const removeDocument = (docId, userName, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/removeFile?docId=${docId}&userName=${userName}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: REMOVE_DOCUMENT, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const approveNewhire = (loginId, role, token) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/updateRole?loginId=${loginId}&role=${role}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: APPROVE_NEWHIRE, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const getEmployeeList = (token, pageNumber, pageSize, searchText) => async (dispatch) => {
  try {
    const safeSearchText = searchText ? searchText : "";
    const res = await fetch(`${BASE_API_URL}/user?roleName=ALL&pageSize=${pageSize}&pageNo=${pageNumber}&searchText=${safeSearchText}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: EMPLOYEE_LIST, payload: resData });
  } catch (error) { }
};

export const getEmployeeDataForExcel = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/employeeDataForExcel`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: EMPLOYEE_DATA_EXCEL, payload: resData });
  } catch (error) { }
};

export const getSupportDataForExcel = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/supportUserDataForExcel`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: SUPPORT_DATA_EXCEL, payload: resData });
  } catch (error) { }
};

export const getContractDataForExcel = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/contractUserDataForExcel`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: CONTRACT_DATA_EXCEL, payload: resData });
  } catch (error) { }
};

export const changePassword = (data) => async (dispatch) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No authentication token found");
      return;
    }
    const res = await fetch(`${BASE_API_URL}/changePassword`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    });
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: CHANGE_PASSWORD, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || 'Unknown error occurred');
    }
  } catch (error) {
    console.error("Password change failed:", error);
  }
};

export const sendOtp = (userName) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/changePasswordOtp?userName=${userName}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    const resData = await res.json();
    if (res.ok) {
      dispatch({ type: FORGOT_PASSWORD, payload: resData });
      return resData;
    } else {
      throw new Error(resData.statusDesc || 'Unknown error occurred');
    }
  } catch (error) {
    return {
      success: false,
      error: error.message || "An error occurred while sending OTP",
    };
  }
};

// verifyOtp action to validate OTP
export const verifyOtp = (validateOtp) => async (dispatch) => {
  try {
    const res = await fetch(
      `${BASE_API_URL}/validateOtp`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(validateOtp),
      }
    );
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      return resData;
    } else {
      return resData.statusDesc || 'Unknown error occurred';
    }
  } catch (error) {
    return {
      error: "An error occurred while verifying OTP",
    };
  }
};

export const changeForgotPassword =
  (userName, newPassword) => async (dispatch) => {
    try {
      const res = await fetch(
        `${BASE_API_URL}/changePassword?userName=${userName}&newPassword=${newPassword}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const resData = await res.json();
      if (res.ok && resData.statusCode === "00") {
        return { success: true };
      } else {
        return {
          success: false,
          error:
            resData.statusDesc ||
            resData.statusMessage ||
            "Password change failed",
        };
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || "An error occurred while changing the password",
      };
    }
  };

export const markEmployeeExit = (data, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/markEmpExit`, { // use path variable
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    }); 
    

    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
  
      dispatch({ type: EXIT_EMPLOYEE, payload: resData });
      return { success: true, data: resData };
    } else {
     
      return {
        success: false,
        error: resData?.statusDesc || `HTTP error: ${res.status}`,
      };
    }
  } catch (error) {
    console.error("Error in markEmployeeExit:", error);
    return {
      success: false,
      error: error.message || "Network error",
    };
  }
};

export const getNewHireTransByLoginId = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/newHireTransaction/${loginId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: NEW_HIRE_TRANSACTION, payload: resData });
  } catch (error) { }
};

export const offerAccepted = (loginId, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/offerAccepted/${loginId}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: OFFER_ACCEPTED, payload: resData });
      return { success: true };
    } else {
      return {
        success: false,
        error: resData.message || "An unknown error occurred",
      };
    }
  } catch (error) { }
};

export const getContractEmployeeList = (token, pageNumber, pageSize, searchText) => async (dispatch) => {
  try {
     const safeSearchText = searchText ? searchText : "";
    const res = await fetch(`${BASE_API_URL}/contractUser?pageSize=${pageSize}&pageNo=${pageNumber}&searchText=${safeSearchText}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: CONTRACT_EMPLOYEE_LIST, payload: resData });
  } catch (error) { }
};

export const getSupportEmployeeList = (token, pageNumber, pageSize, searchText) => async (dispatch) => {
  try {
    const safeSearchText = searchText ? searchText : "";
    const res = await fetch(`${BASE_API_URL}/supportUser?roleName=ALL&pageSize=${pageSize}&pageNo=${pageNumber}&searchText=${safeSearchText}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: SUPPORT_EMPLOYEE_LIST, payload: resData });
  } catch (error) { }
};

export const getEmployeeData = (token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/employeeData`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: EMPLOYEE_DATA, payload: resData });
  } catch (error) { }
};

export const allEmployeeList = (status, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/all-employee-list?status=${status}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    const resData = await res.json();
    dispatch({ type: ALL_EMPLOYEE_LIST, payload: resData });
  } catch (error) { }
};

export const instantOnboarding = (payload, token) => async (dispatch) => {
  try {
    const res = await fetch(`${BASE_API_URL}/instant-onboarding`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json", 
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(payload),
    });

    const resData = await res.json();

    if (res.ok && resData.statusCode === "00") {
      dispatch({ type: INSTANT_ONBOARD, payload: resData });
      return resData;
    } else {
      throw new Error(resData?.statusDesc || "Unknown error occurred");
    }
  } catch (error) {
    console.error("Instant onboarding error:", error); 
    throw error; 
  }
};